
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getScreenDetails, getCreateScreenDetails, follow_unfollow_screen, getAIScreenDetails } from './client/screen-details';
import { mapPaginatorData } from '../utils/data-mappers';
import { HttpClientFront } from './client/http-client-front';


export const useScreenDetailsQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SCREENS + '/'+params.slug, params],
    queryFn: () => getScreenDetails.get( { id:params.slug, ...params } ),
    keepPreviousData: true,
  });
  //console.log("Screen details data:", params, data);
  return {
    product: data?.data,
    screenDetails: data ? data.screen : undefined,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useScreenQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SCREENS, params],
    queryFn: () => getScreenDetails.all( params ),
    keepPreviousData: true,
  });
  //console.log("Screen details data:", params, data);
  return {
    product: data?.data,
    screenDetails: data ? data.screen : undefined,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useCreateScreenQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SCREENS + '/create/new', params],
    queryFn: () => getCreateScreenDetails.all( params ),
    keepPreviousData: true,
  });
  //console.log("Screen query details data:", params, data);
  return {
    product: data?.data,
    screenDetails: data ? data.screen : undefined,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useAIScreenQuery = ( params ) => {
  console.log("params====", params.enabled);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SCREENS + '/create_ai_screen', params],
    queryFn: () => getAIScreenDetails.all( params ),
    enabled: params.enabled,
    keepPreviousData: true,
  });
  console.log("Screen query details data===:", data);
  return {
    product: data ? data.data : null,
    aiError: data?.message || undefined,
    jsonQuery: data?.jsonQuery,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useFollowUnfollowScreen = (screenId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: follow_unfollow_screen,
    onSuccess: () => {
      // 🔁 refetch follow status
      queryClient.invalidateQueries({
        queryKey: ['/check_screen_follow_status/' + screenId],
      });
    },
  });
};

export const useCheckScreenFollowStatus = (screenId) => {
  return useQuery({
    queryKey: ['/check_screen_follow_status/' + screenId],
    queryFn: () => HttpClientFront.get(`/check_screen_follow_status/` + screenId),
    enabled: !!screenId,
  });
}